import AppManagerImpl from "./app-manager";
import EntitlementsImpl from "./entitlements";
import snapshot from "./snapshot";
import subscriptionFactory from "./data-subscription";
import { Glue42 } from "../../glue";
import { InMemoryStore } from "./in-memory";
import { Configuration } from "./types";

export default (config: Glue42.AppManager.Config): Glue42.AppManager.API => {

    if (!config) {
        throw Error("config not set");
    }

    if (!config.agm) {
        throw Error("config.agm is missing");
    }

    const START_ONLY: Glue42.AppManager.Mode = "startOnly";
    const SKIP_ICONS: Glue42.AppManager.Mode = "skipIcons";
    const FULL: Glue42.AppManager.Mode = "full";

    const mode: Glue42.AppManager.Mode = config.mode || START_ONLY;
    if (mode !== START_ONLY && mode !== SKIP_ICONS && mode !== FULL) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        throw new Error(`Invalid mode for appManager lib - ${mode} is not supported`);
    }

    const activities = config.activities;
    const agm = config.agm;
    const logger = config.logger;
    const windows = config.windows;
    let configuration: Configuration = {};
    const appManager = new AppManagerImpl(mode, agm, activities, windows, logger.subLogger("applications"), config.gdMajorVersion, () => configuration);
    const entitlements = new EntitlementsImpl(agm);

    let readyPromise: Promise<Configuration>;
    if (mode === START_ONLY) {
        readyPromise = snapshot(agm, appManager);
    } else {
        const subscription = subscriptionFactory(agm, appManager, entitlements, mode === SKIP_ICONS);
        readyPromise = subscription.start();
    }

    const api: Glue42.AppManager.API = {
        ready: () => readyPromise.then((c) => { configuration = c; }),

        applications: appManager.applications,
        application: appManager.application,
        getConfigurations: appManager.getConfigurations,

        onAppAdded: appManager.onAppAdded,
        onAppRemoved: appManager.onAppRemoved,
        onAppChanged: appManager.onAppChanged,
        onAppAvailable: appManager.onAppAvailable,
        onAppUnavailable: appManager.onAppUnavailable,

        instances: appManager.instances,
        get myInstance() {
            return appManager.getMyInstance();
        },
        get myApplication() {
            return appManager.getMyApplication();
        },

        onInstanceStarted: appManager.onInstanceStarted,
        onInstanceStopped: appManager.onInstanceStopped,
        onInstanceUpdated: appManager.onInstanceUpdated,
        onInstanceStartFailed: appManager.onInstanceStartFailed,

        getRegion: entitlements.getRegion,
        getBranches: entitlements.getBranches,
        getCurrentBranch: entitlements.getCurrentBranch,
        getFunctionalEntitlement: entitlements.getFunctionalEntitlement,
        getFunctionalEntitlementBranch: entitlements.getFunctionalEntitlementBranch,

        setCurrentBranch: entitlements.setCurrentBranch,
        setRegion: entitlements.setRegion,

        currentUser: entitlements.currentUser,

        canI: entitlements.canI,
        canIBranch: entitlements.canIBranch,

        onBranchesChanged: entitlements.onBranchesChanged,

        exit: entitlements.exit,
        restart: entitlements.restart,

        onShuttingDown: entitlements.onShuttingDown,

        inMemory: new InMemoryStore(agm)
    };

    return api;
};
